import {createAction} from "@reduxjs/toolkit";
import axios from "axios";
import {showNotification, clearAll} from '@elements/alert-notification';
import {translate} from '@elements/translations';
import {initInScope} from "@elements/init-modules-in-scope";
//import {sampleFunction} from "../reducer/rootReducer";
import {createActionWithState} from "../utils";
import {getConfigValue} from '@elements/config-utils';
import {getListEndDate, getListItems, getListStartDate} from "../reducer/rootReducer";

const configName = '_orderArchive';

// Base Configuration Data Fetching
export const LIST_DATA_FETCH_ACTION_TYPE = 'list/fetch';
export const LIST_DATA_FETCHED_ACTION_TYPE = 'list/fetched';
export const LIST_DATA_FETCH_FAILED_ACTION_TYPE = 'list/fetch-failed';
export function requireData(filter = {}) {
    console.log('requireData', filter);
    return function (dispatch, getState) {
        let state = getState();

        dispatch({
            type: LIST_DATA_FETCH_ACTION_TYPE
        });


        axios({
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            url: getConfigValue('baseUrl', configName),
            params: filter,
            responseType: 'json'
        }).then(({data}) => {
            console.log('LIST_DATA_FETCHED_ACTION_TYPE', data);
            if (data.success) {
                dispatch({
                    type: LIST_DATA_FETCHED_ACTION_TYPE,
                    payload: data
                });
            }
        }).catch((error) => {
            dispatch({
                type: LIST_DATA_FETCH_FAILED_ACTION_TYPE
            });
        })
    }
}


export const LIST_DATE_CHANGED = 'list/date/changed';

export function changeListDate(date) {
    return function (dispatch, getState) {
        let state = getState();

        const currentStartDate = getListStartDate(state),
            currentEndDate = getListEndDate(state);

        if (currentStartDate === date.startDate && currentEndDate === date.endDate) {
            return
        }

        dispatch(requireData(date));

        //push to history
        if (window.history && window.history.pushState) {
            let url = new URL(window.location.href);
            url.searchParams.set('startDate', date.startDate);
            url.searchParams.set('endDate', date.endDate);
            window.history.pushState({}, '', url.toString());
        }

        dispatch({
            type: LIST_DATE_CHANGED,
            payload: {
                date
            }
        });
    }
}

export const LIST_INVOICES_FETCH_ACTION_TYPE = 'list/invoices/fetch';
export const LIST_INVOICES_FETCHED_ACTION_TYPE = 'list/invoices/fetched';
export const LIST_INVOICES_FETCH_FAILED_ACTION_TYPE = 'list/invoices/fetch-failed';
export function getInvoicesByItemId(id) {
    return function (dispatch, getState) {
        let state = getState(),
            item = getListItems(state).find(item => item.number === id),
            startDate = getListStartDate(state),
            endDate = getListEndDate(state);

        let referencedInvoices = item.referencedInvoices || [],
            referencedDeliveryNotes = item.referencedDeliveryNotes || [];
        const referencedPurchaseOrders = item.referencedPurchaseOrders || [];

        // for d365 items we also need to pass the kendox id
        const d365 = item.d365 ? item.d365 : null;
        const kendox = item.kendox ? item.kendox : null;

        dispatch({
            type: LIST_INVOICES_FETCH_ACTION_TYPE
        });

        axios({
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            url: getConfigValue('baseUrl', configName),
            params: {
                invoiceOrDeliveryNotes: 1,
                referencedInvoices: referencedInvoices,
                referencedDeliveryNotes: referencedDeliveryNotes,
                referencedPurchaseOrders: [referencedPurchaseOrders],
                startDate: startDate,
                endDate: endDate,
                d365,
                kendox
            },
            responseType: 'json'
        }).then(({data}) => {
            if (data.success) {
                dispatch({
                    type: LIST_INVOICES_FETCHED_ACTION_TYPE,
                    payload: data
                });
            }
        }).catch((error) => {
            dispatch({
                type: LIST_INVOICES_FETCH_FAILED_ACTION_TYPE
            });
        })
    }
}